import { render, staticRenderFns } from "./FormLogin.vue?vue&type=template&id=00804eec&"
import script from "./FormLogin.vue?vue&type=script&lang=js&"
export * from "./FormLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00804eec')) {
      api.createRecord('00804eec', component.options)
    } else {
      api.reload('00804eec', component.options)
    }
    module.hot.accept("./FormLogin.vue?vue&type=template&id=00804eec&", function () {
      api.rerender('00804eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormLogin.vue"
export default component.exports